import ModelSubNavigation from './ModelSubNavigation';
import TrimSubNavigation from './TrimSubNavigation';
import FeatureSubNavigation from './FeatureSubNavigation';

export default class ModSubNavigation {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.dom = {
      $features: $('[data-module="Features"]'),
    };
    this.init();
  }

  init() {
    if (this.dom.$features.length) {
      this.features = new FeatureSubNavigation(this.el);
      this.$el.addClass('feature-template');
    } else if (this.$el.hasClass('trim-template')) {
      this.trims = new TrimSubNavigation(this.el);
    } else {
      this.models = new ModelSubNavigation(this.el);
    }
  }
}
